// src/pages/coupons/Coupons.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import CouponsTable from "../../components/coupons/CouponsTable";

const Coupons = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <CouponsTable />
        </WrapperSection>
    );
};

export default Coupons;
